import type { Insight } from "../types/reports.types";

interface InsightCalloutProps {
  insight?: Insight;
}

export default function InsightCallout({ insight }: InsightCalloutProps) {
  if (!insight) return null;

  return (
    <div className={`insightCallout ${insight.tone ?? "info"}`}>
      <strong>{insight.title}</strong>
      <p>{insight.text}</p>
    </div>
  );
}
